import React, { useEffect, useRef } from 'react';

import LoadingOverlay from '@achmadk/react-loading-overlay';
import { useAuthUserContext } from 'app/core/security/authSession';
import { X } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import { lazyLoad } from 'utils/loadable';

import { useOutsideClick } from '../hooks/useOutsideClick';
import { messages } from '../modules/translation';

import { GetMenuItems } from './menu/menu';
import MenuTree from './menu/menuTree';
import { type MenuItem } from './menu/types';
import NavBar from './navbar';
import { useLayoutActions, useLayoutStore } from './store';

const Menu = React.memo(() => {
  const menuOpen = useLayoutStore((state) => state.menuOpen);
  const user = useAuthUserContext();
  const { closeMenu } = useLayoutActions();
  const menuRef = useRef<HTMLDivElement>(null);
  const items: Array<MenuItem> = GetMenuItems(user?.roles ?? []);

  useOutsideClick(menuRef as React.RefObject<HTMLElement>, closeMenu, {
    enabled: menuOpen
  });

  useEffect(() => {
    const theme = user?.claims.find((x) => x.type === 'theme')?.value?.toLowerCase();
    if (theme && theme !== 'light') {
      document.body.className = theme ?? '';
    }
  }, []);
  return (
    <>
      <nav>
        <div className={'navbar-collapse offcanvas-collapse ' + (menuOpen ? 'open' : 'closed')}>
          <div className="text-right mt-3 mb-1 text-uppercase">
            <Link to="#" className="me-2 rounded close-btn" onClick={closeMenu}>
              <X size={32} />
            </Link>
          </div>

          <a href="#" className="d-block px-3 mb-5">
            <div className="img-fluid d-block px-5 menuLogo"></div>
          </a>
          <div ref={menuRef} className="accordion side-menu" id="side-menu">
            <div className="nav-menu-group">
              <div className="nav-menu-collapse collapsed">
                <ul className="list-group list-group-flush d-flex">
                  {user && <MenuTree menuRoot={items} />}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
});

Menu.displayName = 'Menu';

const DefaultComponent: React.FC<any> = (props) => {
  const spinnerOpen = useLayoutStore((state) => state.spinnerOpen);

  return (
    <>
      <LoadingOverlay active={spinnerOpen} spinner text={messages('pleaseWait')}>
        <div className="wrapper d-flex flex-column">
          <div className="flex-fill">
            <Menu />
            <NavBar />
            <div className="container content-body" style={{ marginTop: 88 }}>
              {props.children}
            </div>
          </div>

          <footer className="footer pt-3 pb-1 mt-5">
            <div className="container">
              <div>
                <div className="img-fluid mx-auto mb-2 footerLogo"></div>
              </div>
            </div>
          </footer>
        </div>
      </LoadingOverlay>
    </>
  );
};

export const Default = React.memo(DefaultComponent);

export const DefaultLayout = lazyLoad(
  () => import('../layouts/default'),
  (module) => module.Default
);
